<app-card [loading]="(loading$ | async) ?? false">
  <app-tab-area-list
    [deviceGroups]="deviceGroups$ | async"
    [expandedById]="expandedById$ | async"
    [loading]="(loading$ | async) ?? false"
    [totalCount]="totalCount$ | async"
    [page]="currentPage"
    [pageSize]="currentPageSize"
    (filterChange)="onFilterChange($event)"
    (create)="onCreateDeviceGroup()"
    (triggerAction)="onTriggerAction($event)"
    (setExpanded)="onSetDeviceGroupExpanded($event)"
    (edit)="onEditDeviceGroup($event)"
    (delete)="onDeleteDeviceGroup($event)"
  />
</app-card>
